import { createSelector } from 'reselect';

const selectTrips = (state: any) => state.trips;


export const selectTripsCurrentItem = createSelector([selectTrips], (trips) => trips.current);

export const selectTripsListItems = createSelector([selectTrips], (trips) => trips.list);

export const selectTripsItemById = (itemId: any) =>
    createSelector(selectTripsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTripsQueryItems = createSelector([selectTrips], (trips) => trips.query);

export const selectTripsCreatedItem = createSelector([selectTrips], (trips) => trips.create);

export const selectTripsUpdatedItem = createSelector([selectTrips], (trips) => trips.update);

export const selectTripsReadItem = createSelector([selectTrips], (trips) => trips.read);

export const selectTripsDeletedItem = createSelector([selectTrips], (trips) => trips.delete);

export const selectTripsSearchedItems = createSelector([selectTrips], (trips) => trips.search);

export const selectTripsItemsCount = createSelector([selectTrips], (trips) => trips.count);

export const selectTripsItemsFilter = createSelector([selectTrips], (trips) => trips.filter);